import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgClipboardClock = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.727 9.463h15.698M15.104 3v2.872M8.051 3v2.872M19.429 11.364V8.43c.008-2.624-1.585-4.052-4.156-4.052h-7.39C5.32 4.378 3.72 5.806 3.72 8.43v7.899c0 2.665 1.6 4.127 4.164 4.127h2.15"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20.282 17.138a3.862 3.862 0 1 1-7.724 0 3.862 3.862 0 0 1 7.724 0"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m17.62 18.142-1.222-.73v-1.57"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgClipboardClock);
export default ForwardRef;
